<form #form="ngForm">
  <spk-card [class]="'col-md-4'" meta="{{ getActionText() }} Country" title="{{model.Name}}" [divider]="true">
    <spk-text [name]="'Name'" [maxlength]="200" [(model)]="model.Name"></spk-text>
    <spk-checkbox [name]="'IsInternational'" [(model)]="model.IsInternational"></spk-checkbox>
    <spk-checkbox [name]="'IsActive'" [(model)]="model.IsActive"></spk-checkbox>
  </spk-card>
</form>
